import { ccfRoutes } from '@app/ccf/ccf-routes';
import GuideTemplate from '@shared/components/guide-template';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import supplyFlowDiagram from '../assets/supply-diagram.png';

export default function SupplyFlowIntroPage() {
  const navigate = useNavigate();
  const { report_uuid, flow_uuid } = useParams();

  return (
    <GuideTemplate
      preTitle="ADD SUPPLY FLOW"
      title="Supply flows"
      description={
        <span>
          A flow is a single supply path that your goods take to get to you from
          your suppliers. Our flow creator helps you quickly model your supply
          emissions to a sufficient level of accuracy for your Company Carbon
          Footprint report.
        </span>
      }
      primaryActionText="Get started"
      primaryActionProps={{
        onClick: () =>
          navigate(
            generatePath(ccfRoutes.SUPPLY_FLOW_ABOUT_SUPPLIERS, {
              report_uuid,
              flow_uuid: flow_uuid || '',
            })
          ),
      }}
    >
      <div className="my-8 flex justify-center">
        <img
          src={supplyFlowDiagram}
          alt="Supply flow diagram"
          className="h-auto max-w-full"
          style={{ minWidth: 300, maxWidth: 500 }}
        />
      </div>
    </GuideTemplate>
  );
}
